import { render } from "./TargetList.vue?vue&type=template&id=454cd576&ts=true"
import script from "./TargetList.vue?vue&type=script&lang=ts"
export * from "./TargetList.vue?vue&type=script&lang=ts"

import "./TargetList.vue?vue&type=style&index=0&id=454cd576&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__